
export const isLessThanOneMonthAway = (targetDate: Date): boolean => {
  const currentDate = new Date();
  const oneMonthInMilliseconds = 30 * 24 * 60 * 60 * 1000;
  const timeDifference = targetDate.getTime() - currentDate.getTime();

  return timeDifference < oneMonthInMilliseconds && timeDifference > 0;
}

export const hasDatePassed = (targetDate: Date): boolean => {
  const currentDate = new Date();
  return targetDate < currentDate;
}